export default __webpack_public_path__ + "static/media/team-meet.f923c844.png";